<template>
    <!-- 安装office弹窗 -->
    <div v-if="installStore.installModalVisible" id="installModal" class="install_modal flex-center fixed">
        <div class="install_modal_card">
            <div class="install_modal_head d-flex-y">
                <div class="install_modal_head_icon flex-center f22">⚡</div>
                <div>
                    <div class="install_modal_head_title f16">Windows 一键安装</div>
                    <div class="install_modal_head_subtitle f12">自动下载 · 静默安装 · 购买后一键激活</div>
                </div>
            </div>

            <div id="installStepsList" class="install_steps_list flex flex-col">
                <div v-for="(step, index) in installStore.installSteps" :id="`istep_${index}`" :key="step.text"
                    class="install_step flex items-start" :class="`install_step_${step.status}`">
                    <span :id="`istep_ico_${index}`" class="install_step_icon f18 text-center">{{ step.currentIcon
                        }}</span>
                    <div class="install_step_body">
                        <div class="install_step_title b">{{ step.text }}</div>
                        <div :id="`istep_det_${index}`" class="install_step_detail">{{ step.detailText }}</div>
                    </div>
                </div>
            </div>

            <div class="install_progress_row flex justify-between">
                <span id="installProgressLabel">{{ installStore.installProgressLabel }}</span>
                <span id="installProgressPct">{{ installStore.installProgressPct }}</span>
            </div>
            <div class="install_progress_track overflow-hidden">
                <div id="installProgressBar" class="install_progress_bar h-full"
                    :style="{ width: installStore.installProgressWidth }">
                </div>
            </div>
            <div id="installSubLabel" class="install_sub_label">{{ installStore.installSubLabel }}</div>

            <div v-show="installStore.installDoneVisible" id="installDonePrompt" class="install_done_prompt"></div>

            <button v-show="installStore.installCloseVisible" id="installCloseBtn"
                class="install_close_btn w-full mt10 p10 bn f13 b pointer"
                :class="{ 'is_done': installStore.installDoneVisible }" @click="installStore.closeInstallModal()">
                {{ closeButtonLabel }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
const installStore = useInstallStore();
const closeButtonLabel = computed(() => (installStore.installDoneVisible ? '安装完成' : '✕ 关闭'));
</script>

<style lang="less" scoped>
.install_modal {
    inset: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 9999;
    animation: fadeIn .2s ease;
}

.install_modal_card {
    background: #fff;
    border-radius: 18px;
    padding: 30px 34px;
    width: 480px;
    max-width: 93vw;
    box-shadow: 0 24px 70px rgba(0, 0, 0, .3);
}

.install_modal_head {
    gap: 12px;
    margin-bottom: 22px;
}

.install_modal_head_icon {
    width: 44px;
    height: 44px;
    background: linear-gradient(135deg, #6366F1, #7C3AED);
    border-radius: 10px;
    flex-shrink: 0;
}

.install_modal_head_title {
    font-weight: 900;
    color: var(--primary);
}

.install_modal_head_subtitle {
    color: #888;
    margin-top: 2px;
}

.install_steps_list {
    gap: 8px;
    margin-bottom: 18px;
}

.install_step {
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    border-left: 3px solid transparent;
    transition: all .3s ease;
    opacity: .35;
    background: #F7F8FA;
}

.install_step_active {
    opacity: 1;
    background: var(--primary-light);
    border-left-color: var(--primary);
}

.install_step_completed {
    opacity: 1;
    background: #F0F9F0;
    border-left-color: #107C10;
}

.install_step_failed {
    opacity: 1;
    background: #FEF2F2;
    border-left-color: #DC2626;
}

.install_step_icon {
    width: 24px;
    margin-top: 1px;
    flex-shrink: 0;
}

.install_step_body {
    flex: 1;
    min-width: 0;
}

.install_step_title {
    font-size: 13.5px;
    color: #222;
}

.install_step_detail {
    font-size: 11.5px;
    color: #aaa;
    margin-top: 2px;
}

.install_progress_row {
    margin-bottom: 6px;
    font-size: 11.5px;
    color: #999;
}

.install_progress_track {
    background: #F0F0F0;
    border-radius: 99px;
    height: 10px;
    margin-bottom: 6px;
}

.install_progress_bar {
    background: linear-gradient(90deg, #6366F1, #06B6D4);
    border-radius: 99px;
    transition: width .4s ease;
}

.install_sub_label {
    font-size: 11px;
    color: #aaa;
    min-height: 16px;
    margin-bottom: 14px;
}

.install_close_btn {
    border-radius: 8px;
    color: #888;
    background: #F3F3F3;
    transition: all .2s ease;

    &.is_done {
        color: #fff;
        background: linear-gradient(135deg, rgb(16, 124, 16), rgb(10, 92, 10));
        box-shadow: 0 8px 20px rgba(16, 124, 16, .22);
    }
}
</style>
